import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {host} from '../../controller/communication';
import {ICourseFileDownload} from "@institutsitya/sitya-common/types/api/user";
import {FileType} from "@institutsitya/sitya-common/types/model/file";
import {faDownload} from "@fortawesome/pro-solid-svg-icons";
import {faExternalLinkAlt} from "@fortawesome/pro-solid-svg-icons";

export interface IFileItemProps {
    file: ICourseFileDownload;
}

export const FileItem: React.FunctionComponent<IFileItemProps> = (props) => {

    const url = host + props.file.url;
    const isAudio = /\.(mp3|m4a|aac|ogg|wav)$/i.test(props.file.name);

    if (isAudio) {
        return (
            <div className="audioitem">
                <div className="audioitem-title">
                    <span className="ml-2">{props.file.name}</span>
                </div>
                <audio controls preload="none" src={url}>
                    <span className="translate">Ihr Browser kann diese Audiodatei nicht abspielen.</span>
                </audio>
                <a href={url} target="_blank" rel="noreferrer" className="audioitem-download">
                    <span className="icon is-small">
                        <FontAwesomeIcon icon={faDownload} className="fa-sm" />
                    </span>
                    <span className="ml-2">Download</span>
                </a>
            </div>);
    }

    return (
        <a href={url} target="_blank" rel="noreferrer" className="fileitem is-block is-fullwidth">
            <span className="icon is-small">
                <FontAwesomeIcon icon={props.file.type === FileType.External ? faExternalLinkAlt : faDownload} className="fa-sm" />
            </span>
            <span className="fileitem-name ml-2">{props.file.name}</span>
        </a>);
}
